<template>
  <main class="deal">
<div v-show="checkHideContents(FirstLayer)">
    <div class="container">
      <div class="rowView pageFirstView">
        <div class="areaPageTitle">
          <h1 class="_kanji">お見積り</h1>
        </div>
				<p>
製作費用については、ご相談ください。内容を伺った上、お見積りいたします。
				</p>
      </div>
			<section class="tips">
				<div class="container">
					<div class="rowView">
						<h2>Tips</h2>
						<div class="noteContent">
							<p>
以下の点をおさえてご相談いただけると、スムーズです。
							</p>
							<ul>
<li>納期</li><li>素材</li><li>ロット数</li><li>設計図</li><li>ご予算</li>
							</ul>
						</div>
						<div class="noteContent">
<p>
プロトタイプ製造などのご依頼は、打ち合わせ段階からご相談いただけると、より良いものを効率よく製造することができます。
</p>
						</div>
					</div>
				</div>
			</section>

		</div>

    <section class="tagJumpTarget" id="DealPrice">
      <div class="areaH2">
        <h2>料金について</h2>
      </div>
      <div class="container">
        <div class="rowView">
					<p>
詳しくは、電話またはフォームからお問い合わせください。
          </p>
<router-link class="pageLinkButton marginBottom4em" to="/customer/contact" >問い合わせフォーム</router-link>

          <p>
類似した製作物をお伝えいただければ見積もりがしやすくなります。
					</p>
<router-link class="pageLinkButton" to="/products?list=1" >製作事例</router-link>
        </div>
      </div>
    </section>

    <section class="tagJumpTarget productFlow" id="DealLine">
      <div class="areaH2">
        <h2>納品までの流れ</h2>
      </div>
      <div class="container">
        <div class="rowView">
					<ul>
						<li class="_header">
<p>お客様</p>
<h3>流れ</h3>
<p>弊社</p>
						</li>
						<li>
<p>製作物の内容（概要）、納期、数などをおまとめいただき、ご連絡ください</p>
<h3>お問い合わせ<br>見積もり依頼</h3>
<p>お伝えいただいた情報を元に対応調整可能かを判断させていただきます</p>
						</li>
						<li>
<p>設計図、素材、ご予算などを正確に見積もりが可能な情報を揃えて参加いただきます</p>
<h3>打ち合わせ</h3>
<p>不明点など明確にし、難しい場合も技術的な点を話し合いながら確実な製品製作をご提案させていただきます。</p>
						</li>
						<li>
<p></p>
<h3>見積もり作成</h3>
<p>技術的なこと以外に、期間、製作数など考慮した最終見積もりをお渡しいたします</p>
						</li>
						<li>
<p>見積もり期限内でご返答いただきます</p>
<h3>ご発注</h3>
<p></p>
						</li>
						<li>
<p>初期ロット製品の確認結果を連絡お願いします</p>
<h3>製作</h3>
<p>大量生産前に、確認用の初期ロット製造品をお渡しします。ご確認いただいた後、必要ロット数の生産に入ります。</p>
						</li>
						<li>
<p></p>
<h3>検査・梱包</h3>
<p>合格品は品質に影響が出ないような梱包を行います。</p>
						</li>
						<li>
<p></p>
<h3>納品</h3>
<p>品質に影響しないような配送方法を選択し確実にお届けいたします。</p>
						</li>
					</ul>
        </div>
      </div>
    </section>
</div>
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: 'deal',
  components:{
  },
  data: function () {
    return {
			pageTitle:"お見積り",
			description:"豊嶋精密工業株式会社へ製作のご依頼される場合の費用、工程の情報です",
			keywords:"お見積り 費用 製作工程",
			ogType:"article",
		}
	},
  mounted: function() {
//インナーナビ情報通知
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
//背景通知
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
  updated: function() {
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

/*head情報をセットする*/
    this.$store.commit('updateCurrentTitle', this.pageTitle)
    this.$store.commit('updateCurrentDescription', this.description)
    this.$store.commit('updateCurrentKeywords', this.keywords)
    this.$store.commit('updateCurrentOgUrl', this.isUrl)
    this.$store.commit('updateCurrentOgType', this.ogType)
    this.$store.commit('updateCurrentOgDesc', this.description)
    this.$store.commit('updateLinkCanonical', '')
		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())
  },
}
</script>

<style>
</style>